/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { IconCalendar, ButtonSecondary } from '@americanexpress/dls-react';
import styleObject from '../../../../styles/EnhancedDataTable/EnhancedTableFilter/datePicker';

const DateIconButton = forwardRef(({
  iconFilled, onClick, label, id, isDisable,
}, ref) => (
  <ButtonSecondary
    id={id}
    aria-label={label}
    icon={<IconCalendar filled={iconFilled} />}
    size="sm"
    onClick={onClick}
    theme={styleObject}
    ref={ref}
    disabled={isDisable}
  />
));

DateIconButton.displayName = 'DateIconButton';

DateIconButton.propTypes = {
  /** The label of the button to open the calendar and switch dates */
  label: PropTypes.string.isRequired,
  /** If true, the DateIcon is filled. */
  iconFilled: PropTypes.bool.isRequired,
  /** onClick of IconButton */
  onClick: PropTypes.func.isRequired,
  /** For DatePicker, the id of the DatePicker.
   * For DateRangePicker, either the start id or the end id. */
  id: PropTypes.string.isRequired,
};

export default DateIconButton;
